module.exports = __webpack_public_path__ + "static/ADIDAS_CERTIFICATE-792fd2c65dd742a3adef2f5218e3bdff.png";